import GoodsType from "enum/GoodsType";

export const getGoodsType = ({isPddShop, isJdShop}) => {
    let goodsType;
    if (isPddShop) {
        goodsType = GoodsType.PDD
    } else if (isJdShop) {
        goodsType = GoodsType.JD
    } else {
        goodsType = GoodsType.SELF
    }

    return goodsType;
}